import React, { Component } from "react";

import NeurosphereContainer from "../containers/NeurosphereContainer";

class NeurospherePage extends Component {
  componentWillMount() {
    document.title = "Neurosphere Simulator";
  }

  render() {
    return (
      <div className="body-container pt-4">
        <div className="container">
          <a name="skipnav" id="skipnav">
            <h1>Neurosphere Simulator Tool</h1>
          </a>
          <NeurosphereContainer
            simTour={this.props.simTour}
            closeTour={this.props.closeTour}
          />
        </div>
      </div>
    );
  }
}

export default NeurospherePage;
